import React from 'react';
import ReportViewer from "./base/ReportViewer";

const DepotClients = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"Depotclientreport"}/>
        </div>
    );
}
export default DepotClients;